import React from "react";
import { Box, Table, Sheet, Skeleton, Typography } from "@mui/joy";

export function PriceComparisonSkeleton({ supplierCount = 3, rowCount = 5 }) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "hidden",
                bgcolor: "background.surface",
            }}
        >
            <Box
                sx={{
                    px: 2.5,
                    py: 1.5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid",
                    borderColor: "rgba(128, 128, 128, 0.2)",
                    bgcolor: "rgba(128, 128, 128, 0.05)",
                    backdropFilter: "blur(12px)",
                }}
            >
                <Box>
                    <Skeleton variant="text" width={180} height={24} />
                    <Skeleton variant="text" width={140} height={16} />
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                    <Skeleton
                        variant="rectangular"
                        width={80}
                        height={32}
                        sx={{ borderRadius: "4px" }}
                    />
                    <Skeleton
                        variant="rectangular"
                        width={120}
                        height={32}
                        sx={{ borderRadius: "4px" }}
                    />
                </Box>
            </Box>

            <Sheet sx={{ flex: 1, overflow: "auto" }}>
                <Table stickyHeader size="sm" borderAxis="bothBetween">
                    <thead>
                        <tr>
                            <th style={{ width: 220, paddingLeft: 16 }}>
                                <Skeleton variant="text" width={80} />
                            </th>
                            {[...Array(supplierCount)].map((_, i) => (
                                <th key={i} style={{ textAlign: "center", minWidth: 140 }}>
                                    <Box display="flex" justifyContent="center" py={0.5}>
                                        <Skeleton variant="text" width={100} />
                                    </Box>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {[...Array(rowCount)].map((_, ri) => (
                            <tr key={ri}>
                                <td style={{ paddingLeft: "16px" }}>
                                    <Box>
                                        <Skeleton variant="text" width={140} sx={{ mb: 0.5 }} />
                                        <Skeleton variant="text" width={80} />
                                    </Box>
                                </td>
                                {[...Array(supplierCount)].map((_, ci) => (
                                    <td key={ci} style={{ textAlign: "center" }}>
                                        <Box display="flex" flexDirection="column" alignItems="center" gap={0.5} py={1}>
                                            <Skeleton variant="text" width={60} />
                                            <Skeleton variant="text" width={40} />
                                        </Box>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td style={{ fontWeight: 800, paddingLeft: "16px" }}>
                                <Skeleton variant="text" width={120} />
                            </td>
                            {[...Array(supplierCount)].map((_, i) => (
                                <td key={i} style={{ textAlign: "center", paddingTop: "12px", paddingBottom: "12px" }}>
                                    <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                                        <Skeleton variant="text" width={90} height={28} />
                                        <Skeleton variant="rectangular" width={70} height={24} sx={{ borderRadius: "sm" }} />
                                    </Box>
                                </td>
                            ))}
                        </tr>
                    </tfoot>
                </Table>
            </Sheet>
        </Box>
    );
}

export default PriceComparisonSkeleton;
